"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BouncerService = void 0;
const tsyringe_1 = require("tsyringe");
const RPCJSONService_1 = require("../httpService/RPCJSONService");
const proxyWalletService_1 = require("../proxyWalletService/proxyWalletService");
const JSONRPCMethods_enum_1 = require("../../../../models/JSONRPCMethods.enum");
const required_1 = require("../../../../helpers/required/required");
const fetchRoomService_1 = require("../../../utils/services/fetchRoomService/fetchRoomService");
const rightService_1 = require("../../../utils/services/rightService/rightService");
const metamaskService_1 = require("../metamask/metamaskService");
const httpService_1 = require("../../../utils/services/httpService/httpService");
const environementService_1 = require("../../../utils/services/environmentService/environementService");
const memory_cache_1 = __importDefault(require("memory-cache"));
let BouncerService = class BouncerService {
    constructor(messagingService, fetchRoomService, rightService, rpcService, metamaskService, httpService, environementService) {
        this.messagingService = messagingService;
        this.fetchRoomService = fetchRoomService;
        this.rightService = rightService;
        this.rpcService = rpcService;
        this.metamaskService = metamaskService;
        this.httpService = httpService;
        this.environementService = environementService;
        this._cache = new memory_cache_1.default.Cache();
    }
    getMyProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._cache.get('bouncerUserProfile')) {
                this._cache.put('bouncerUserProfile', this.rpcService.signedRPCCall(this.environementService.environment.bouncerRPCURL, JSONRPCMethods_enum_1.JSONRPCMethods.bouncer.users.getMyProfile, {}).then(profile => (profile === null || profile === void 0 ? void 0 : profile.payload) || {}));
            }
            return this._cache.get('bouncerUserProfile');
        });
    }
    updateMyProfile(profile) {
        this._cache.del('bouncerUserProfile');
        return this.rpcService.signedRPCCall(this.environementService.environment.bouncerRPCURL, JSONRPCMethods_enum_1.JSONRPCMethods.bouncer.users.updateMyProfile, profile);
    }
    getUserRooms() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._cache.get('bouncerUserRooms')) {
                const getUserRoom = () => __awaiter(this, void 0, void 0, function* () {
                    const userRooms = yield this.rpcService.signedRPCCall(this.environementService.environment.bouncerRPCURL, JSONRPCMethods_enum_1.JSONRPCMethods.bouncer.rooms.getUserRooms, {});
                    userRooms.forEach(room => this.fetchRoomService.addToCache(room.roomId, room.roomDetails));
                    return userRooms;
                });
                this._cache.put('bouncerUserRooms', getUserRoom());
            }
            return this._cache.get('bouncerUserRooms');
        });
    }
    joinRoom(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            this._cache.del('bouncerUserRooms');
            const { roomId } = parameters;
            required_1.requiredDefined(roomId, 'roomId is required');
            const params = {
                roomId
            };
            return this.rpcService.signedRPCCall(this.environementService.environment.bouncerRPCURL, JSONRPCMethods_enum_1.JSONRPCMethods.bouncer.rooms.join, params);
        });
    }
    getRecommendedRooms(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.environementService.environment.bouncerURL}/rooms/recommended`;
            const recommendedRooms = yield this.httpService.fetchWithCache(url);
            recommendedRooms.forEach(d => this.fetchRoomService.addToCache(d.roomId, d.roomDetails));
            return recommendedRooms;
        });
    }
    getFeaturedRooms(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.environementService.environment.bouncerURL}/rooms/featured`;
            const featuredRooms = yield this.httpService.fetchWithCache(url);
            featuredRooms.forEach(d => this.fetchRoomService.addToCache(d.roomId, d.roomDetails));
            return featuredRooms;
        });
    }
    getVerifiedRoomsId() {
        return __awaiter(this, void 0, void 0, function* () {
            const chainId = this.environementService.environment.chainId;
            const url = `https://raw.githubusercontent.com/Arianee/spkz-metadata/main/${chainId}/verified-rooms.json`;
            const verifiedRoomsId = yield this.httpService.fetchWithCache(url);
            return verifiedRoomsId;
        });
    }
    getSpecialRoomsId() {
        return __awaiter(this, void 0, void 0, function* () {
            const chainId = this.environementService.environment.chainId;
            const url = `https://raw.githubusercontent.com/Arianee/spkz-metadata/main/${chainId}/special-rooms.json`;
            const specialRoomsId = yield this.httpService.fetchWithCache(url);
            return specialRoomsId;
        });
    }
};
BouncerService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [proxyWalletService_1.ProxyWalletService,
        fetchRoomService_1.FetchRoomService,
        rightService_1.RightService,
        RPCJSONService_1.RPCJSONService,
        metamaskService_1.MetamaskService,
        httpService_1.HttpService,
        environementService_1.EnvironmentService])
], BouncerService);
exports.BouncerService = BouncerService;
//# sourceMappingURL=bouncerService.js.map